const state = {
    brands: [],
    brand: {},
    error: null,
    editBrand: false,
    brandsAll: []
};

export default state;
